import { NgClass } from '@angular/common';
import { AfterViewInit, ChangeDetectionStrategy, Component, Input, OnDestroy, ViewEncapsulation } from '@angular/core';
import { MatChip, MatChipAvatar, MatChipTrailingIcon } from '@angular/material/chips';
import { MatIcon } from '@angular/material/icon';
import { MatTooltip } from '@angular/material/tooltip';
import { ReviewService } from '@ng-cloud/badger-core';
import { ConciseDurationPipe } from '@ng-cloud/badger-core/common/pipes/concise-duration.pipe';
import { ClassDirective } from '@ngbracket/ngx-layout/extended';
import { LayoutAlignDirective, LayoutDirective, LayoutGapDirective } from '@ngbracket/ngx-layout/flex';
import moment from 'moment';
import { Subscription } from 'rxjs';
import { HasAccessDirective } from '../directives/has-access.directive';

@Component({
  selector: 'bt-age-queue-chips',
  templateUrl: './age-queue-chips.component.html',
  styleUrls: ['./age-queue-chips.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [
    ClassDirective,
    ConciseDurationPipe,
    HasAccessDirective,
    LayoutAlignDirective,
    LayoutDirective,
    LayoutGapDirective,
    MatChip,
    MatChipAvatar,
    MatChipTrailingIcon,
    MatIcon,
    MatTooltip,
    NgClass
  ]
})
export class AgeQueueChipsComponent implements AfterViewInit, OnDestroy {
  @Input() filter = '';

  constructor(private reviewService: ReviewService) {
  }

  readonly inspectThresholdDuration: moment.Duration = moment.duration(
    30,
    'seconds'
  );
  readonly insightThresholdDuration: moment.Duration = moment.duration(
    30,
    'minutes'
  );
  ageInspect: moment.Duration = moment.duration(0);
  ageInsight: moment.Duration = moment.duration(0);

  private statSubscription: Subscription;

  ngAfterViewInit(): void {
    // Ongoing stat changes
    setTimeout(
      () =>
        (this.statSubscription = this.reviewService
          .stats_age()
          .subscribe((response) => this.updateReviewAgeStats(response))),
      1000
    );
  }

  ngOnDestroy() {
    this.statSubscription && this.statSubscription.unsubscribe();
    this.reviewService.cable().disconnect();
  }

  updateReviewAgeStats(response: any) {
    this.ageInspect = moment.duration(response['inspectQueueAge']);
    this.ageInsight = moment.duration(response['insightQueueAge']);
  }
}
